import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag, Table } from 'antd';
import { FileText, Eye } from 'lucide-react';
import dayjs from 'dayjs';
import { getContractType } from '../../../../utils/contractTypes';
import { StatusTag, IconAction, IconActions, EmptyState, CollapsibleCard } from '../../../common';
import TradeStatusTag from './tradeStatus';

export default function StoreContractsSection({ contracts }) {
    const navigate = useNavigate();
    const safeContracts = Array.isArray(contracts) ? contracts : [];

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-sm font-medium text-surface-900">{text}</span>
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            render: (type) => {
                const t = getContractType(type);
                return <Tag color={t.color}>{t.label}</Tag>;
            }
        },
        {
            title: 'Vencimiento',
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            render: (date) => <span className="text-sm text-surface-600 tabular-nums">{date ? dayjs(date).format('DD/MM/YYYY') : '—'}</span>
        },
        {
            title: 'Estado',
            key: 'status',
            render: (_, record) => <TradeStatusTag record={record} />
        },
        {
            title: '',
            key: 'action',
            width: 64,
            align: 'right',
            render: (_, record) => (
                <IconActions>
                    <IconAction icon={<Eye />} label="Ver" onClick={() => navigate(`/dashboard/trade/contracts/contract?id=${record._id}`)} />
                </IconActions>
            )
        }
    ];

    return (
        <CollapsibleCard
            title="Contratos"
            icon={<FileText />}
            iconTone="violet"
            flush={safeContracts.length > 0}
            badges={
                <StatusTag tone="neutral">
                    {safeContracts.length} {safeContracts.length === 1 ? 'contrato' : 'contratos'}
                </StatusTag>
            }>
            {safeContracts.length > 0 ? (
                <Table dataSource={safeContracts} columns={columns} rowKey="_id" pagination={false} size="middle" scroll={{ x: 'max-content' }} />
            ) : (
                <EmptyState icon={<FileText />} title="Sin contratos" description="No hay contratos activos para este PDV" />
            )}
        </CollapsibleCard>
    );
}
